<template>

    <b-modal id="my-quizzes-set-modal" centered>
        <template #modal-title>{{ modalTitle }}</template>
        <div class="row">
            <div class="col-md-4">

                <div class="form-group">
                    <legend>{{ t.__('Ikona') }}</legend>
                    <file-manager-image-select :input-name="'icon'" :value="form.icon" v-model="form.icon" :mime-types="'image/gif,image/jpeg,image/png,image/tiff,image/bmp,image/x-xbitmap'" :crop-available="true" :crop-aspect-ratio="240/320" :width="300"></file-manager-image-select>
                </div>

            </div>
            <div class="col-md-8">

                <b-form-group
                    id="my-quizzes-add-set-display-name-group"
                    description=""
                    :label="t.__('Nazwa wyświetlana')"
                    :disabled="processing"
                    valid-feedback=""
                    :invalid-feedback="form.errors.get('display_name')"
                    :state="form.errors.state('display_name')">
                    <b-form-input id="my-quizzes-add-set-display-name" v-model="form.display_name" :state="form.errors.state('display_name')" trim></b-form-input>
                </b-form-group>

                <b-form-group
                    id="my-quizzes-add-set-display-description-group"
                    description=""
                    :label="t.__('Opis wyświetlany (max. 200 znaków)')"
                    :disabled="processing"
                    valid-feedback=""
                    :invalid-feedback="form.errors.get('display_description')"
                    :state="form.errors.state('display_description')">
                    <b-form-textarea id="my-quizzes-add-set-display-description" v-model="form.display_description" max="200" :state="form.errors.state('display_description')" trim></b-form-textarea>
                </b-form-group>

            </div>
        </div>
        <template #modal-footer>
            <b-button variant="secondary" @click="close">{{ t.__('Anuluj') }}</b-button>
            <b-button variant="success" @click="save" :disabled="processing" v-text="processing ? t.__('Zapisuję...') : t.__('Zapisz')"></b-button>
        </template>
    </b-modal>

</template>

<script>

import {inputValidators} from '../mixins/inputValidators';
import Image from "../file-manager/classes/Image";

export default {

    name: 'MyQuizzesSetModal',

    mixins: [inputValidators],

    data() {
        return {
            eventHub: window.eventHub,
            action: null,
            outputIdentificationName: null,
            form: new Vue.prototype.Form({
                icon: null,
                display_name: null,
                display_description: null
            }),
            processing: false
        }
    },

    computed: {
      modalTitle() {
          return this.action === 'add' ? t.__('Dodaj zestaw') : t.__('Edytuj zestaw')
      }
    },

    beforeMount() {

        this.eventHub.$on('my-quizzes-add-set', () => {
            this.action = 'add';
            this.$bvModal.show('my-quizzes-set-modal')
        });

        this.eventHub.$on('my-quizzes-edit-set', (set) => {
            this.action = 'edit';
            this.outputIdentificationName = set.output_identification_name;
            this.form.setData({
                icon: new Image(set.icon_url),
                display_name: set.display_name,
                display_description: set.display_description
            });
            this.$bvModal.show('my-quizzes-set-modal')
        });

        this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
            if (modalId === 'my-quizzes-set-modal') {
                this.action = null;
                this.outputIdentificationName = null;
                this.form.setData({
                    icon: null,
                    display_name: null,
                    display_description: null
                });
            }
        });

    },

    methods:  {

        close() {
            this.$bvModal.hide('my-quizzes-set-modal');
        },

        save() {
            this.processing = true;
            if (this.action === 'add') {
                this.form.post('/my-quizzes/store-set')
                    .then(response => {
                        this.eventHub.$emit('my-quizzes-update-sets', response.sets);
                        this.processing = false;
                        this.close();
                    })
                    .catch(error => {
                        console.log(error);
                        this.processing = false;
                    });
            } else {
                this.form.put('/my-quizzes/update-set/' + this.outputIdentificationName)
                    .then(response => {
                        this.close();
                        this.eventHub.$emit('my-quizzes-update-sets', response.sets);
                        this.processing = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.processing = false;
                    });
            }

        }

    }

}

</script>

<style scoped>

</style>
